import {FeatureStatus, FeatureTracking} from '@utils/feature_tracking';

class FeatureTrackingBuilder {
    private $id: string;
    private $name: string;
    private $status: FeatureStatus;
    private $position: number | null | undefined = null;
    private $parentId: string | null | undefined = null;
    private $variationId: string | null | undefined = null;
    private $labels: object | null | undefined = null;

    constructor(id: string, name: string, status: FeatureStatus) {
        this.$id = id;
        this.$name = name;
        this.$status = status;
    }

    id(id: string) {
        this.$id = id;
        return this;
    }

    getId() {
        return this.$id;
    }

    name(name: string) {
        this.$name = name;
        return this;
    }

    getName() {
        return this.$name
    }

    status(status: FeatureStatus) {
        this.$status = status;
        return this;
    }

    getStatus() {
        return this.$status
    }

    position(position: number | null | undefined) {
        this.$position = position;
        return this;
    }

    getPosition() {
        return this.$position;
    }

    parentId(parentId: string | null | undefined) {
        this.$parentId = parentId;
        return this;
    }

    getParentId() {
        return this.$parentId;
    }

    variationId(variationId: string | null | undefined) {
        this.$variationId = variationId;
        return this;
    }

    getVariationId() {
        return this.$variationId;
    }

    labels(labels: object | null | undefined) {
        this.$labels = labels;
        return this;
    }

    getLabels() {
        return this.$labels;
    }

    build() {
        return new FeatureTracking(this);
    }
}

export default FeatureTrackingBuilder